import { render, staticRenderFns } from "./stand-alone.vue?vue&type=template&id=fc36e910&scoped=true&"
import script from "./stand-alone.vue?vue&type=script&lang=ts&"
export * from "./stand-alone.vue?vue&type=script&lang=ts&"
import style0 from "./stand-alone.vue?vue&type=style&index=0&id=fc36e910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc36e910",
  null
  
)

export default component.exports